<template>
  <u-navbar :bgColor="bgColor" :left-icon="leftIcon"
            :leftIconColor="leftIconColor"  :leftText="leftText"
            :isShowLeft="isShowLeft" :placeholder="true"
            :title="title" :titleStyle="titleStyle"
            @leftClick="leftClick"
  >
    <view
        class="u-nav-slot"
        slot="right"
    >
      <u-icon :color="rightIconColor" @click="rightIconClick"
          :name="rightIcon"
          size="20"
      ></u-icon>
    </view>
  </u-navbar>
</template>

<script>
export default {
  name: "index",
  props:{
    title:{
      type: String,
      default: ''
    },
    leftText:{
      type: String,
      default: ''
    },
    leftIconColor:{
      type: String,
      default: '#fff'
    },
    leftIcon:{
      type: String,
      default: 'arrow-left'
    },

    bgColor:{
      type: String,
      default: '#409effc1'
    },
    isShowLeft:{
      type: Boolean,
      default: true
    },
    customBack:{
      type: String,
      default: ''
    },
    customType:{
      type: String,
      default: 'redirectTo'
    },
    rightIcon:{
      type: String,
      default: ''
    },
    rightIconColor:{
      type: String,
      default: '#fff'
    },
    rightClick:{
      default:()=>{}
    }
  },
  data(){
    return{
      titleStyle:{
        color: "#fff"
      }
    }
  },
  methods:{
    leftClick(){
      if (this.customBack){
        if (this.customType == 'navigateBack'){
          console.log('返回')
          uni.navigateBack({
            delta: 1,
            success: function () {
              console.log('返回成功')
            },
            fail: function (e) {
              console.log(e)
            }
          });
        }else{
          uni.$u.route({
            url: this.customBack,
            type: this.customType
          }).catch(e=>{
            console.log(e)
          })
        }
      }else{
        uni.redirectTo();
      }
    },
	rightIconClick(){
    console.log(1)
		// this.rightClick();
    this.$emit('rightClick')
    }
  }
}
</script>

<style scoped>

</style>
